/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface TrackItDataTypeLongDto
 */
export interface TrackItDataTypeLongDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeLongDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataTypeLongDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeLongDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeLongDto
     */
    definition?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof TrackItDataTypeLongDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataTypeLongDto
     */
    readonly commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeLongDto
     */
    readonly lastComment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeLongDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataTypeLongDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeLongDto
     */
    $type?: TrackItDataTypeLongDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItDataTypeLongDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItDataTypeLongDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeLongDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItDataTypeLongDtoTypeEnum = typeof TrackItDataTypeLongDtoTypeEnum[keyof typeof TrackItDataTypeLongDtoTypeEnum];



/**
 * Check if a given object implements the TrackItDataTypeLongDto interface.
 */
export function instanceOfTrackItDataTypeLongDto(value?: unknown): value is TrackItDataTypeLongDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItDataTypeLongDtoTypeEnum)[0];
}

export function TrackItDataTypeLongDtoFromJSON(json: any): TrackItDataTypeLongDto {
    return TrackItDataTypeLongDtoFromJSONTyped(json, false);
}

export function TrackItDataTypeLongDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItDataTypeLongDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'definition': json['definition'] == null ? undefined : json['definition'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'value': json['value'] == null ? undefined : json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItDataTypeLongDtoToJSON(value?: Omit<TrackItDataTypeLongDto, 'commentCount'|'lastComment'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'definition': value['definition'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'unit': value['unit'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

